import React, { useEffect, useState, useContext } from "react";
import { useForm } from 'react-hook-form';
import { DynamicSelect } from "../../components/DynamicSelect";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import api from '../../services/api';
import Swal from "sweetalert2";
import { StyledForm } from "../../styled-components/StyledForm.style";
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";


const getCancelamentos = async (codeType) => {
    let cancelamentos = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { codeType }
    }
    try {
        const response = await api.get(`Settings/genericlist/list`, config);
        cancelamentos = response.data.data;
    } catch (err) { }
    return cancelamentos;
}

export const ModalGrupoDeAtividadesCancel = ({ isOpen, onAfterOpen, onRequestClose, selectedGrupoAtividade }) => {
    const { register } = useForm();
    var [cancelamentos, setCancelamentos] = useState([]);
    var [cancelamento, setCancelamento] = useState(null);
    var [idCancelamento, setIdCancelamento] = useState(null);
    var [descricao, setDescricao] = useState(null);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const getCancelamento = (currentValue, value) => {
        var cancelamentoResult = cancelamentos.filter(function (o) {
            return o.key == value;
        });
        cancelamento = cancelamentoResult[0].value;
        idCancelamento = cancelamentoResult[0].key;
        setCancelamento(cancelamento);
        setIdCancelamento(idCancelamento);
    };

    const handleDescricao = (valor) => {
        descricao = valor;
        setDescricao(descricao);
    };

    const cancelarGrupoAtividadePost = async () => {
        let result = null;
        let params = [];
        let msg = descricao?.target?.value;
        selectedGrupoAtividade.Value.forEach(grupoAtividade => {
            if(!descricao?.target?.value && idCancelamento == 4) {
                registrationFailure("Descrição do cancelamento é um campo obrigatório para Tipo de Cancelamento Outro!");
            }
            else {
                if(descricao?.target?.value){
                    msg = descricao?.target?.value;
                }
                else {
                    msg = cancelamento;
                }
            }
            params.push({
                IdTimesheet: grupoAtividade.idTimesheet,
                IdTimesheetItemGrupoAtividade: grupoAtividade.idTimesheetItemGrupoAtividade,
                idTipoAtividadeCancelado: idCancelamento,
                mensagem: msg
            })
        });

        try {
            const response = await api.post(`Timesheet/grupo-atividade/cancelar`, params);
            onRequestClose();
            registrationSuccess();
            result = response.data;
            setTimeout(() => {
                window.location.reload(false);
            }, 1000)
        } catch (err) {
            //registrationFailure();
            return result;
        }
    };

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Cancelamento realizado com sucesso",
            icon: "success",
            confirmButtonText: "OK",
        });
    }

    const registrationFailure = (message = "Ops, ocorreu um erro ao realizar o cancelamento!") => {
        Swal.fire({
            title: "Atenção",
            text: message,
            icon: "error",
            confirmButtonText: "OK",
        });
    }

    useEffect(() => {
        const asyncFn = async () => {
            const cancelamentos = await getCancelamentos(43);
            if (!!cancelamentos) {
                setCancelamentos(cancelamentos)
            }
        }
        asyncFn()
    }, []);

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <Flex style={{ display: 'flex !important' }}>
                <StyledForm>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <p className="modal-title">Cancelar Grupo de Atividade</p>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <div>
                                    <p className="modal-info">Status</p>
                                    <p className="modal-info-data">{(selectedGrupoAtividade?.Value || [])[0]?.status}</p>
                                    <p className="modal-info">Período</p>
                                    <p className="modal-info-data">{(selectedGrupoAtividade?.Value || [])[0]?.periodoInicio} - {(selectedGrupoAtividade?.Value || [])[0]?.periodoFim}</p>
                                </div>
                            </div>
                        </Flex.Item>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <div>
                                    <p className="modal-info">Perito</p>
                                    <p className="modal-info-data">{selectedGrupoAtividade?.perito?.nome}</p>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div style={{ width: '100%' }} className="position-relative form-group">
                                <DynamicSelect required="required" register={register} placeholder={''} valuetext={cancelamento} label={'Tipo Cancelamento'} name={'idCancelamento'} options={cancelamentos} keyValue={'key'} keyLabel={'value'} paramMethod={getCancelamento} />
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div style={{ width: '100%' }} className="position-relative form-group">
                                <textarea rows="3" maxLength="500" className="input-form" placeholder='Descrição' name='descricao' onBlur={handleDescricao} />
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group modal-align-center">
                                <input className='default-button-red' value='Cancelar' type="button" onClick={cancelarGrupoAtividadePost} />
                            </div>
                        </Flex.Item>
                    </Flex>
                </StyledForm>
            </Flex>
        </Modal>
    );
};
